import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: { userDetails: null },
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload || null;
    },
    clearUserDetails: (state) => {
      state.userDetails = null;
    },
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserDetailsState = (state: { [key: string]: any }) => state.user.userDetails;
export const { setUserDetails, clearUserDetails } = userSlice.actions;
export default userSlice.reducer;
